import React from "react"
import Cabecalho from "../Cabecalho"
import { FormasDePagamentoForm } from "./components/FormasDePagamentoForm"

export function ConfiguracaoFormasDePagamento() {
    return (
        <>
            <Cabecalho pagina="Formas de Pagamento" />
            <FormasDePagamentoForm />
        </>
    )
}
